import script from "./CommonSwiper.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommonSwiper.vue?vue&type=script&setup=true&lang=ts"

import "./CommonSwiper.vue?vue&type=style&index=0&id=738f0750&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-738f0750"]])

export default __exports__